import { useUnhandledRejectionErrors } from './GlobalErrorBoundary';
export const CatchUnhandledRejectionErrors = () => {
  useUnhandledRejectionErrors(event => {
    console.warn('%c [JL] event - event', 'font-size: 16px; color:  red;', event);
  });
  return null;
};